import React from 'react'
import { Form, Input, Button } from 'antd'
import { func } from 'prop-types'

import { useCreateApplicationType } from '@graphql/mutations'

function ManageApplicationTypeForm({ afterSubmit }) {
  const [form] = Form.useForm()
  const [createApplicationType, { loading }] = useCreateApplicationType()

  const onFinish = data => {
    createApplicationType({
      variables: {
        data: { ...data },
      },
      refetchQueries: ['GetApplicationTypesQuery'],
    }).then(callback => afterSubmit(callback), form.resetFields())
  }

  return (
    <Form onFinish={onFinish} form={form}>
      <Form.Item
        name="name"
        rules={[
          {
            required: true,
            message: `Campo obrigatório`,
          },
        ]}
        hasFeedback
      >
        <Input placeholder="Nome do tipo de aplicação" size="large" autoFocus />
      </Form.Item>

      <Button
        type="primary"
        htmlType="submit"
        size="large"
        disabled={loading}
        block
      >
        Criar tipo de aplicação
      </Button>
    </Form>
  )
}

ManageApplicationTypeForm.propTypes = {
  afterSubmit: func,
}

ManageApplicationTypeForm.defaultProps = {
  afterSubmit: null,
}

export default ManageApplicationTypeForm
